import React from 'react';
import {
	Autocomplete,
	AutocompleteProps,
	TextField,
	TextFieldProps,
} from '@mui/material';
import rpcShared from '@rockpapercoin/rpc-shared';
import { PaymentType } from '#types';

export type PaymentInstallmentOfflinePaymentTypeSelectProps = {
	label?: string | React.ReactNode;
	value?: PaymentType;
	onChange?: ( value: PaymentType | undefined ) => void;
	onBlur?: () => void;
	errorText?: TextFieldProps['helperText'];
	'data-cy'?: string;
} & Partial<AutocompleteProps<PaymentType, undefined, true, true>>;

export const PaymentInstallmentOfflinePaymentTypeSelect: React.FC<
	PaymentInstallmentOfflinePaymentTypeSelectProps
> = ( {
	label = 'Payment method',
	value,
	onChange,
	onBlur,
	errorText,
	className,
	[ 'data-cy' ]: dataCy,
	...autocompleteProps
} ) => {
	return (
		<Autocomplete<PaymentType, undefined, true, true>
			openOnFocus
			blurOnSelect
			autoHighlight
			disableClearable
			{ ...autocompleteProps }
			options={ rpcShared.invoices.offlinePaymentTypes as PaymentType[] }
			value={ value || '' }
			renderInput={ ( params ) => (
				<TextField
					{ ...params }
					variant='standard'
					label={ label }
					error={ !!errorText }
					helperText={ errorText }
					onBlur={ onBlur }
					slotProps={ {
						...params.slotProps,
						htmlInput: { ...params.slotProps.htmlInput, 'data-cy': dataCy },
					} }
				/>
			) }
			onChange={
				// keypress events aren't handled here, so this will only ever get contact selects
				( _, value ) =>
					typeof value === 'string' && value in PaymentType
						? onChange?.( value as PaymentType )
						: undefined
			}
		/>
	);
};
